import { render, staticRenderFns } from "./fees-container.vue?vue&type=template&id=7ba8aec8"
import script from "./fees-container.vue?vue&type=script&lang=ts"
export * from "./fees-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports